import styled from "@emotion/styled";
import { Theme, Typography } from "@yuno/design-system-web";
import { useContext, useMemo, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { MainContext } from "../../../context/main-context";
import { useDraggable } from "../../../hooks/use-draggable";
import { DraggableItem } from "./draggable-item";

const Title = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => theme.typography.small.regular};
  margin-bottom: 24px;
`;

const getListStyle = (_) => ({
  width: "100%",
  position: "relative",
});

const getItemStyle = (_, draggableStyle) => ({
  userSelect: "none",
  margin: `0 0 20px 0`,
  ...draggableStyle,
});

const DraggableContainer = styled.div<{ theme?: Theme; isDragging?: boolean }>`
  position: absolute;
  left: 8px;
  right: 0;
  margin-bottom: 20px;
  border: ${({ theme, isDragging }) =>
    isDragging && `1px dashed  ${theme.palette.vivid.brand}`};
  background: ${({ theme, isDragging }) =>
    isDragging && theme.palette.pastel.brand};
  border-radius: 24px;
`;

export const DraggableList = ({
  data,
  title,
  onChange,
  onSwitch,
  fixedList = [],
}) => {
  const {
    reorder,
    draggableContainerStyles,
    placeholderProps,
    onDragUpdate,
    onDragEnd,
  } = useDraggable({ data, onEnd: onChange });

  return (
    <div>
      <Title>{title}</Title>
      {fixedList.length > 0 &&
        fixedList.map((el, key) => (
          <DraggableItem id={"elem2"} item={el} key={key} locked />
        ))}
      <DragDropContext onDragEnd={onDragEnd} onDragUpdate={onDragUpdate}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {data.map((el, key) => (
                <Draggable
                  draggableId={el.payment_method_type}
                  index={key}
                  key={el.payment_method_type}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      <DraggableItem
                        id={el.payment_method_type === "CARD" && "elem1"}
                        item={el}
                        onSwitch={(ev) => onSwitch(ev, el)}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
              {placeholderProps.clientY !== undefined && (
                <DraggableContainer
                  isDragging={snapshot.isDraggingOver}
                  style={draggableContainerStyles}
                />
              )}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};
